/**
 * App-level scroll reset. Retries are cancellable so a later "scroll to pricing"
 * navigation is not undone by timers from an earlier route change.
 */

let timeoutIds = [];
let rafIds = [];

export const cancelScrollPageToTop = () => {
  timeoutIds.forEach((id) => window.clearTimeout(id));
  rafIds.forEach((id) => window.cancelAnimationFrame(id));
  timeoutIds = [];
  rafIds = [];
};

export const scrollPageToTop = () => {
  if (typeof window === "undefined") return;

  cancelScrollPageToTop();

  const active = document.activeElement;
  if (active && typeof active.blur === "function" && active !== document.body) {
    active.blur();
  }

  const run = () => {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch {
      window.scrollTo(0, 0);
    }

    if (document.scrollingElement) {
      document.scrollingElement.scrollTop = 0;
    }
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    document
      .querySelectorAll(".main-content, .app-layout-main, .app-layout-shell")
      .forEach((node) => {
        if (node && typeof node.scrollTop === "number") {
          node.scrollTop = 0;
        }
      });
  };

  run();

  const outerRaf = window.requestAnimationFrame(() => {
    run();
    rafIds.push(window.requestAnimationFrame(run));
  });
  rafIds.push(outerRaf);

  // iOS keyboard / layout settle retries
  [0, 50, 150, 400].forEach((delay) => {
    timeoutIds.push(window.setTimeout(run, delay));
  });
};

export default scrollPageToTop;
